import I18n from 'I18n';
import { fromString, toMoment } from 'foundations-components/transitional/utils/SimpleDate';
import { CUSTOM_DATE_FORMAT } from '../constants/DateConstants';
export const formatDate = date => I18n.moment(date).format('MM/DD/YYYY');
export const formatDateForApi = date => toMoment(date).format(CUSTOM_DATE_FORMAT);
export const toSimpleDate = date => fromString(date, CUSTOM_DATE_FORMAT);